import React from 'react';
import Grid from '@material-ui/core/Grid';

const TopLayer = ({ children, size }) => {
  console.log('SIZE ', size);
  return (
    <Grid style={{ size: '20vh' }} xs={12} item container alignItems="flex-end">
      {children}
    </Grid>
  );
};

export default TopLayer;
